define('shoptheme/components/cartware/video',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"videojs",
	"videojs-vimeo",
	"videojs-youtube"
], function(
	$,
	Component,
	BEM,
	videojs
) {
	return Component.create({
		elements: [],
        sliderSlideClass: "." + BEM.buildElementClassname("cartware-slider-slide"),
        videoWidgetClass: "." + BEM.buildBlockClassname("video-widget"),
        videoOverlayClass: "." + BEM.buildElementClassname("cartware-slider-slide", "loading-overlay"),

		$init: function() {
			var self = this;
			var	elements = $("video[data-custom-setup]");
			var	count = elements.length;
            var cwSlider = $('.cartware-slider');
            var sliderInstance = cwSlider.data('cartware_slider/instance');

			elements.each(function() {
				var video = $(this),
					setup = video.data("custom-setup");

				if ("autoInitialization" in setup && setup.autoInitialization === false) {
					return;
				}

                (video.data("is-slide") == 1) ? self.initVideoSlide(this, true) : self.initVideo(this);
                if (!--count) {
                    self.resizeVideoJS();
                }
			});

            if (cwSlider.length > 0 && sliderInstance !== undefined) {
                sliderInstance.on('ready', function (event) {
                    self.resizeVideoJS();
                    self.handleActiveVideoSlide(cwSlider);
                });

                cwSlider.on('cartware_slider/slide_after', function (event) {
                    self.handleActiveVideoSlide($(event.currentTarget));
                });
            }

            // self.handleActiveVideoSlide(cwSlider);

			 // Initialize the function
			window.onresize = function() {
				self.resizeVideoJS();
			}; // Call the function on resize
		},

        initVideo: function(element) {
            var self = this;
            var video = $(element);
            var tabContentClass = "." + BEM.buildElementClassname("tabs", "tab-content");
            video
                .closest(tabContentClass)
                .on("tab-content-active", function(e) {
                    self.resizeVideoJS();
                });
            videojs(element, video.data("custom-setup"), function() {
                var player = this;
                if (video[0].hasAttribute("muted")) {
                    player.muted(true);
                }
                player.videoAspectRatio = video.data("aspect-ratio");
                self.elements.push(player);
                self.resizeVideoJS();
            });
        },

        initVideoSlide: function(element) {
            var self = this;
            var videoSlide = $(element);
            var slideContainer = videoSlide.closest('.cartware-slider-item-wrap');
            var slider = videoSlide.closest('.cartware-slider');
            var instance = slider.data('cartware_slider/instance');
            if (slideContainer.css('display') === 'none') {
                self.fixMobileActiveThumbSelection();
                instance.pauseAutoslide(false);
            } else {
                instance.pauseAutoslide(true);
            }
            videojs(element, videoSlide.data("custom-setup"), function() {
                var player = this;
                player.loadingSpinner.show();
                if (element.hasAttribute("muted")) {
                    player.muted(true);
                }

                player.videoAspectRatio = videoSlide.data("aspect-ratio");

                self.elements.push(player);

                // slider.trigger('resize');
                slider.one('mouseenter', function() {
                    videoSlide.removeClass('hide-controls');
                });

                slider.trigger('resize');
            });
        },

        handleActiveVideoSlide: function(slider) {
            var self = this;
            var instance = slider.data('cartware_slider/instance');
            var video = instance.activeItem.find('.video-js');
            if ($(instance.activeItem).css('display') === 'none') {
                self.fixMobileActiveThumbSelection();
                instance.pauseAutoslide(false);
            } else {
                if (video.length > 0) {
                    var videoOverlay = instance.activeItem.find(self.videoOverlayClass);
                    var player = videojs(video[0]);

                    if (player.ended()) {
                    	// player.reset();
						player.currentTime(0);
					}

                    player.play();
					instance.pauseAutoslide(true);

                    if (!("__component_events_bound" in player)) {
						player.on('timeupdate', function () {
							if (!videoOverlay.hasClass('disabled') && this.currentTime() > 0) {
								videoOverlay.addClass('disabled');
							}
						});
						player.on('ended', function () {
							if (instance.settings.autoslide == true) {
								videoOverlay.removeClass('disabled');
								instance.next();
							}
						});

						player["__component_events_bound"] = true;
					}
                } else {
                    instance.pauseAutoslide(false);
                }
            }
        },

        fixMobileActiveThumbSelection: function() {
            var self = this;
            var activeThumb = $('.thumbs-container .thumb-video.active');
            if (activeThumb.css('display') === 'none') {
                var nextThumb = activeThumb.closest('li').next().find('.thumb');
                    activeThumb.removeClass('active');
                    nextThumb.addClass('active');
                    self.fixMobileActiveThumbSelection();
            }
        },

		resizeVideoJS: function() {
			var windowHeight = $(window).height();

			$.each(this.elements, function(index, value) {
				var player = $(document.getElementById(value.id()));
				var width = player.parent().width(),
					height = width / value.videoAspectRatio,
					maxHeight = Math.min(player.offsetParent().height(), windowHeight);

				if (player.closest(".b_cartware-slider-slide--video, .b_tabs__tab-content").length) {
					maxHeight = Infinity;
				}

				if (height > maxHeight) {
					width = width * maxHeight / height;
					height = maxHeight;
				}

				player
					.width(width|0)
					.height(height|0);

				player.trigger("gigaset.content.change");
			});
            this.fixMobileActiveThumbSelection();
		}
	});
});
